import React from 'react'
import './TextField.css'

const TextField = ({
  label,
  width,
  height,
  value,
  onChange,
  placeholder,
  readOnly,
  error,
  required,
  type,
  disabled,
  margin,
  hide = false,

  studentForm,
  ...props
}) => {
  return (
    <div className="textfield-wrapper" style={{ width, height, margin }}>
      {label && (
        <label
          style={{
            marginBottom: studentForm ? '10px' : '',
          }}
          className="textfield-label"
        >
          {label}
          {required && <span className="req">*</span>}
        </label>
      )}
      {!hide && (
        <input
          style={{
            margin,
            borderRadius: studentForm ? '8px 8px 0px 0px' : '',
          }}
          className={`textfield-input ${error ? 'textfield-error' : ''}`}
          value={value}
          onChange={onChange}
          height={height}
          readOnly={readOnly}
          placeholder={placeholder}
          type={type ? type : 'text'}
          {...props}
          disabled={disabled}
          required={required}
        />
      )}
    </div>
  )
}

export default TextField
